import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-binary-lamp',
  templateUrl: './binary-lamp.component.html',
  styleUrls: ['./binary-lamp.component.css']
})
export class BinaryLampComponent implements OnInit {
@Input() public switch;
  constructor() { }

  ngOnInit() {
  }

}
